export enum HelpMeWriteType {
  APPROACH_EMAIL = "APPROACH_EMAIL",
  FOLLOW_UP_EMAIL = "FOLLOW_UP_EMAIL",
}
